import { config } from "../config.js";
import { fieldOf } from "../sim/scale.js";

// スケール感の見た目の部分(倍率 world.scale は src/sim/scale.js)。

// 床のガイドの高さ(動ける範囲の下端より下)。床ごと倍率で大きくなる
export function floorYOf(world) {
  return -fieldOf(world).halfHeight - config.graphics.depth.floorGap * (world.scale || 1);
}

// 読みやすさの目印(自機の足元の輪・敵の弾・経験値・着弾予告)を、どれだけ大きく見せるか。
// 倍率どおりに大きくすると自機が小さく見える効果が消え、そのままだと引いた画面で読めないので、その間(倍率の markFollow 乗)
export function markScale(world) {
  return Math.pow(world.scale || 1, config.scale.markFollow);
}
